import React, {useRef, useEffect} from "react";
import * as am4core from "@amcharts/amcharts4/core";
import * as am4charts from "@amcharts/amcharts4/charts";
import am4themes_animated from "@amcharts/amcharts4/themes/animated";
import { useSelector } from "react-redux";
import { getOptionsSelector } from "../../Slices/optionSlice";


interface AlarmComboChartProps {
  values?: string
  id: string
  data: any
  timeSpan?:string
  clickHandler?: any
  type?:string;
  series?: {
    name?:string,
    unit?:string,
    color?:string
    }
}

const chartColors = [
  am4core.color("green"),
  am4core.color("red"),
  am4core.color("pink"),
  am4core.color("yellow"),
  am4core.color("orange"),
  am4core.color("blue"),
];

// function am4themes_myTheme(target) {
//   if (target instanceof am4core.ColorSet) {
//     target.list = chartColors;
//   }
// }
// am4core.useTheme(am4themes_myTheme);

const RunningPeriodsChart = (props: AlarmComboChartProps) =>{
  const options = useSelector(getOptionsSelector);

  const chart = useRef(null);
  am4core.options.autoDispose = true;

  useEffect(() => {
    
    chart.current = am4core.create(props.id, am4charts.XYChart);
    if (props.data.length > 0){
      createChart(props.data);
    }
    return function cleanup() {
      if (chart.current) {
        chart.current.dispose();
      }
    };
  }, [props.data]);

  const createChart = (data:any) =>{
    chart.current.data = data;
    //chart.current.cursor = new am4charts.XYCursor();
      chart.current.cursor = new am4charts.XYCursor();
      chart.current.cursor.behavior = "panX";
      chart.current.mouseWheelBehavior = "zoomX";
    let title = chart.current.titles.create()
    title.text = props.timeSpan;

    //legends
    chart.current.legend = new am4charts.Legend();
    chart.current.legend.position = "right";
    chart.current.legend.valign = "top";
    chart.current.legend.width = 80;
    chart.current.legend.labels.template.truncate = false;
    chart.current.legend.labels.template.wrap = true;
    chart.current.legend.marginLeft = 0;
    chart.current.legend.marginRight = 0;
    chart.current.legend.marginTop = 0;
    chart.current.legend.fontSize = "11px";
    chart.current.legend.itemContainers.template.paddingTop = 3;
    chart.current.legend.itemContainers.template.paddingBottom = 2;
    //legend styles
    var markerTemplate = chart.current.legend.markers.template;
    markerTemplate.width = 10;
    markerTemplate.height = 10;

    let categoryAxis = chart.current.xAxes.push(new am4charts.CategoryAxis());
    categoryAxis.dataFields.category = "id";
    categoryAxis.renderer.grid.template.location = 0;
    categoryAxis.renderer.minGridDistance = 30;
    categoryAxis.renderer.cellStartLocation = 0.2
    categoryAxis.renderer.cellEndLocation = 0.8
    categoryAxis.cursorTooltipEnabled = true;

    let label = categoryAxis.renderer.labels.template;
    label.truncate = true;
    label.maxWidth = 100;
    label.fontSize = 12;
    label.tooltipText = "{category}";
    label.rotation = -60;
    label.horizontalCenter = "right";

    let valueAxis = chart.current.yAxes.push(new am4charts.ValueAxis());
    valueAxis.title.text = "count";
    valueAxis.min = 0;

    createSeries(props.values);

    function createSeries(customerDevice:string){
        let series = chart.current.series.push(new am4charts.ColumnSeries());
        series.dataFields.valueY = customerDevice;
        series.dataFields.categoryX = "id";
        series.columns.template.tooltipText = "{id}: [bold]{valueY}[/]";
        series.name = customerDevice;
        series.yAxis = valueAxis;

        var columnTemplate = series.columns.template;
        columnTemplate.strokeWidth = 2;
        columnTemplate.strokeOpacity = 1;
        //columnTemplate.fill = seriesColor;
        //columnTemplate.stroke = seriesColor;
        columnTemplate.width = am4core.percent(70);
    }

  }

  return (
    <div id={props.id} style={{ width: "100%", height: "100%"}}></div>
  );
}



export default RunningPeriodsChart;

